module.exports = __webpack_public_path__ + "media/images/user/home-c973cf38f27a9a6aecc0f1cce2846035.svg";